// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HeroContent Component Styles */

.scl--web-component-hero-content {
  width: 100%;
  z-index: 2;
  max-height: 430px;
}

.scl--web-component-hero-title {
  font-family: var(--primary-font);
  font-weight: 500;
  font-style: normal;
  font-size: 110px;
  line-height: 130px;
  letter-spacing: 0px;
  vertical-align: middle;
  margin: 20px 0px;
  color: var(--hero-content-hero-text-color);
  color: transparent;

  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.scl--web-component-hero-title-line1 {
  display: block;
  background: linear-gradient(271.67deg, #FFFFFF 33.5%, #ADADAD 118.62%, #DDDDDD 219.22%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

}

.scl--web-component-hero-title-line2 {
  display: block;
  background: linear-gradient(269.75deg, #FFFFFF 47.56%, #FFFFFF 87.61%, #ADADAD 110.84%, #DDDDDD 158.31%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.scl--web-component-hero-button {
  min-width: 150px;
  background: transparent;
  display: flex !important;
  flex-direction: row !important;
  justify-content: center !important;
  align-items: center !important;
  font-size: 16px;
}

.scl--web-component-hero-button:hover {
  background: #FFFFFF1A;
  border-color: #797979;
}

.scl--web-component-hero-button span:first-child {
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  letter-spacing: 0.5px;
  text-align: center;
}

.scl--web-component-hero-button span:last-child {
  font-size: 16px;
  color: #FFFFFF;
}`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/title/hero/css/heroContent.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;;EAElB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,uFAAuF;EACvF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;;AAEvB;;AAEA;EACE,cAAc;EACd,wGAAwG;EACxG,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* HeroContent Component Styles */\n\n.scl--web-component-hero-content {\n  width: 100%;\n  z-index: 2;\n  max-height: 430px;\n}\n\n.scl--web-component-hero-title {\n  font-family: var(--primary-font);\n  font-weight: 500;\n  font-style: normal;\n  font-size: 110px;\n  line-height: 130px;\n  letter-spacing: 0px;\n  vertical-align: middle;\n  margin: 20px 0px;\n  color: var(--hero-content-hero-text-color);\n  color: transparent;\n\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n\n.scl--web-component-hero-title-line1 {\n  display: block;\n  background: linear-gradient(271.67deg, #FFFFFF 33.5%, #ADADAD 118.62%, #DDDDDD 219.22%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n\n}\n\n.scl--web-component-hero-title-line2 {\n  display: block;\n  background: linear-gradient(269.75deg, #FFFFFF 47.56%, #FFFFFF 87.61%, #ADADAD 110.84%, #DDDDDD 158.31%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n\n.scl--web-component-hero-button {\n  min-width: 150px;\n  background: transparent;\n  display: flex !important;\n  flex-direction: row !important;\n  justify-content: center !important;\n  align-items: center !important;\n  font-size: 16px;\n}\n\n.scl--web-component-hero-button:hover {\n  background: #FFFFFF1A;\n  border-color: #797979;\n}\n\n.scl--web-component-hero-button span:first-child {\n  font-size: 16px;\n  font-weight: 400;\n  color: #FFFFFF;\n  letter-spacing: 0.5px;\n  text-align: center;\n}\n\n.scl--web-component-hero-button span:last-child {\n  font-size: 16px;\n  color: #FFFFFF;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
